import { FC, lazy } from 'react';
import { QuickFilter } from 'src/apis/monolith/types';
import { PageSpinner } from 'src/components/spinner-container';
import { useQuickFilters } from 'src/pages/transport/auctions/overview/use-quick-filters';
import {
  useCapacityCategories,
  useMarketAreas,
} from 'src/pages/transport/network-points/overview/use-lookups';
import {
  useApiSearchParams,
  useNPSearch,
} from 'src/pages/transport/network-points/overview/use-np-search';
import { usePageParams } from 'src/pages/transport/network-points/overview/use-page-params';

const Page = lazy(() => import('./page'));

export const NetworkPointsOverview: FC = () => {
  const quickFilters = useQuickFilters();

  if (!quickFilters.response) return <PageSpinner />;

  return (
    <NetworkPointsOverviewWithQuickFilters
      quickFilters={quickFilters.response.data}
    />
  );
};

const NetworkPointsOverviewWithQuickFilters: FC<{
  quickFilters: QuickFilter[];
}> = ({ quickFilters }) => {
  const pageParams = usePageParams();

  const marketAreas = useMarketAreas();
  const capacityCategories = useCapacityCategories();

  const apiSearchParams = useApiSearchParams(pageParams.value, quickFilters);
  const npSearch = useNPSearch(apiSearchParams);

  if (
    !(marketAreas.response && capacityCategories.response && npSearch.response)
  )
    return <PageSpinner />;

  return (
    <Page
      marketAreas={marketAreas}
      capacityCategories={capacityCategories}
      quickFilters={quickFilters}
      apiSearchParams={apiSearchParams}
      npSearch={npSearch}
    />
  );
};
